<div class="container">
  <div class="header">
    <div class="header-left">
      <!--<button mat-flat-button color="accent" (click)="createBeyondSupplier()">New Beyond Supplier</button>-->

      <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="" #filter>
      </mat-form-field>
    </div>

    <div class="header-right">
      <!--<app-table-options [rowData]="data" ></app-table-options>-->
      <span>{{ this.timeSinceLastRefresh }} since last refresh</span>
    </div>
  </div>

  <div class="beyond-supplier-table">
    <mat-table class="beyond-supplier-table" [dataSource]="source" matSort matSortActive="id" matSortDirection="desc">
      <ng-container [matColumnDef]="def.field" *ngFor="let def of colDefs">
        <mat-header-cell *matHeaderCellDef mat-sort-header [sortActionDescription]="'Sort by ' + def.header">
          <div class="table-header">{{ def.header }}</div>
        </mat-header-cell>

        <mat-cell *matCellDef="let element">
          <input readonly
              *ngIf="def.format == undefined"
              [value]="element[def.field]">
          <input readonly
              *ngIf="def.format == 'titlecase'"
              [value]="element[def.field] | titlecase">
          <input  readonly
              *ngIf="def.format == 'currency'"
              [value]="element[def.field] | currency">
          <input  readonly
              *ngIf="def.format == 'date'"
              [value]="element[def.field] | date: 'mediumDate'">
          <input readonly
              *ngIf="def.format == 'phone'"
              [value]="element[def.field] | phone">
          <div class="action-buttons" *ngIf="def.format == 'actions'">
              <button mat-stroked-button color="primary" (click)="editBeyondSupplier(element)" class="action-btn">Edit</button>
              <button mat-stroked-button color="warn" (click)="suspendBeyondSupplier(element)" class="action-btn">Suspend</button>
              <button mat-stroked-button color="warn" (click)="terminateBeyondSupplier(element)" class="action-btn">Terminate</button>
          </div>        
        </mat-cell>

      </ng-container>

      <mat-header-row *matHeaderRowDef="this.displayedCols"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedCols;"></mat-row>

      <!-- theoretically should work but angular doesn't like it
      <mat-row *matNoDataRow>
        <mat-cell [attr.colspan]="colDefs.length">No data matching the filter "{{filter.value}}"</mat-cell>
      </mat-row>
      -->
    </mat-table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of beyond suppliers"></mat-paginator>
</div>
